module.exports = __webpack_public_path__ + "herb-garden-1.jpg?ad7b022f5d9dbddc87643d31fd71fa04";


//////////////////
// WEBPACK FOOTER
// ./src/images/herb-garden-1.jpg
// module id = 148
// module chunks = 0